export const CURRENT_CYCLE_EXCLUDED_AMENDS_KEYS = new Set([
    "draft.approved",
    "draft.rejected",
    "draft.submitted",
    "draft.returnedToEditing",
])
